export const fullScreenButtonClick = () => {
    const fullscreenButton: any = document.querySelector(
        '#containers-view button.image-gallery-fullscreen-button',
      );
      fullscreenButton && fullscreenButton.click();
}